import React from "react";
import { TextField } from "@mui/material";
import LoadingScreen from "../../../../../../shared/components/LoadingScreen";
import { ToastContainer } from "react-toastify";
import Print from "../../../../../../printConfigration/PrintConfigration";
import { ModalWrapper } from "../../../../../../shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";
import { Customerdata, Getdata } from "src/shared/services/interface";

interface Props {
  getorder: Getdata | undefined;
  confirm: boolean;
  emaihas: boolean;
  agent: boolean;
  setAgent: (val: boolean) => void;
  Customer: Customerdata | undefined;
  email: string;
  geterror: string | null;
  customeremailid: (e: React.ChangeEvent<HTMLInputElement>) => void;
  updateCustomerEmail: () => void;
  orderemailmsg: (getorder: any, email: string, received: string, orderId: string, finalAmount: number, remaining: string) => void;
  Doneorder: () => void;
  ordersucess: any;
  printData: any;
  filteredCustomerId: string | number;
  SendMail: { Blue: string; name: string };
  Cancel: { Cancel: string; name: string };
  Update: { Blue: string; name: string };
  SendMessage: { Blue: string; name: string };
  Dones: string;
  loading: boolean;
  setConfirm: (val: boolean) => void;
}

const PaymentConfirmModal: React.FC<Props> = ({ getorder, confirm, setConfirm, emaihas, agent, setAgent, Customer, email, geterror, customeremailid, updateCustomerEmail, orderemailmsg, Doneorder, ordersucess, printData, filteredCustomerId, SendMail, Cancel, Update, SendMessage, Dones, loading,
}) => {
  const handleDone = () => {
    Doneorder();
    setConfirm(false);
  };


  return (
    <>
      {confirm && (
        <ModalWrapper title="Payment Completed" onClose={handleDone} showCloseButton={true} width="max-w-lg">
          <div className="flex flex-col items-center text-center space-y-4">
            <img src={Dones} alt="" className="w-48 h-48" />
            <p className="text-lg font-medium text-gray-700">Your payment has been completed successfully</p>
            <div className="mt-6 gap-3 flex justify-center">
              {emaihas ? (
                <CommonButtons
                  label="Send Mail"
                  onClick={() => {
                    orderemailmsg(
                      getorder,
                      Customer?.Email ?? "",
                      String(ordersucess?.payments[0]?.ReceivedAmount ?? ""),
                      ordersucess?.Orderid ?? "",
                      Number(ordersucess?.Finalamount ?? 0),
                      String(ordersucess?.RemainingAmount ?? "")
                    );
                  }}
                />
              ) : (
                <>
                  {/* <div style={{ marginRight: "10px" }} id="done_btn"> */}
                  <CommonButtons label='Send Mail' onClick={() => setAgent(!agent)} />
                  {/* </div> */}

                  {/* Email Input Modal */}
                  {!Customer?.Email && agent && (
                    <ModalWrapper title="Please enter the Email address" onClose={() => setAgent(false)} showCloseButton={true} width="max-w-lg">
                      <div className="edit-popupscreen">
                        <div className="input_textfield_order">
                          <TextField
                            className="input_email_text"
                            id="outlined-basic"
                            label="Email ID"
                            sx={{ width: "100%" }}
                            value={email}
                            error={!!geterror}
                            helperText={geterror || "Please enter your email in the format 'id@example.com'"}
                            onChange={customeremailid}
                            variant="outlined"
                          />
                        </div>
                        <div className="modal-footer flex justify-end mt-4 gap-2">
                          <div>
                            <CommonButtons className='w-36' variant="outlineDanger" label='Cancel' onClick={() => setAgent(false)} />
                          </div>
                          <div>
                            <CommonButtons className='w-36' label='Update' onClick={updateCustomerEmail} disabled={!email || !!geterror} />
                          </div>
                        </div>
                      </div>
                    </ModalWrapper>
                  )}
                </>
              )}
              <div>
                <CommonButtons label='Send Message' onClick={() => setAgent(false)} />
              </div>
              <div onClick={handleDone}>
                <Print PrintData={{ ...printData, Paid: printData.Paid ?? 0, clientId: filteredCustomerId || "0" }} BtnName={"Done"} username="" />
              </div>
            </div>
          </div>

          {loading && <LoadingScreen />}
          <ToastContainer />
        </ModalWrapper>
      )}
    </>
  );
};

export default PaymentConfirmModal;
